import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Operator id")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Operator origin")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Operator name")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Resources")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Action")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Request id")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Occurrence")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Created at")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Updated at")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Payload")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_audit_log_resources = _resolveComponent("audit-log-resources")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h5", null, "Audit Log #" + _toDisplayString(_ctx.auditLog.id), 1),
    _createVNode(_component_q_list, {
      class: "q-mb-lg",
      bordered: "",
      padding: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.auditLog.operator.id), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.auditLog.operator.origin), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.auditLog.operator.name), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createVNode(_component_audit_log_resources, {
                  resources: _ctx.auditLog.resources
                }, null, 8, ["resources"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.auditLog.action), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.auditLog.requestId), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.auditLog.occurrence), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.auditLog.createdAt), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.auditLog.updatedAt), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium self-start" }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createElementVNode("pre", null, _toDisplayString(_ctx.auditLog.payload), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_q_btn, {
      to: { name: _ctx.AuditLogsRouteNames.LIST, query: { page: _ctx.route.query.page } },
      label: "Back to listing",
      color: "primary",
      outline: "",
      "no-caps": "",
      unelevated: ""
    }, null, 8, ["to"])
  ]))
}